import { Callout } from './index';

/**
 * What metadata removal is not.
 *
 * This exists because the distinction is easy to get wrong in the other direction, and getting it
 * wrong would be the most damaging thing CleanFile could do: someone deciding a file is safe to
 * publish on the strength of a claim this app is in no position to make. Metadata is data *about*
 * the picture, stored beside it in the container. A watermark can be encoded into the picture
 * itself — SynthID and similar schemes work that way — and nothing here touches a single pixel, by
 * design. So the honest statement is the narrow one.
 */
export function LimitationsNote({ className }: { className?: string }) {
  return (
    <div className={className}>
      <Callout tone="neutral" title="What this does not cover">
        CleanFile removes supported metadata and provenance information stored inside the file. It cannot
        guarantee removal of invisible watermarks embedded directly into image pixels, audio or video content.
        Removing metadata does not change who created a file, and it is not a way to make AI-generated content
        undetectable.
      </Callout>
    </div>
  );
}
